import api from "@/core/api/axios";
import { AxiosRequestConfig, AxiosResponse } from "axios";

export async function sendRequest(
  token: string | undefined | null,
  config: AxiosRequestConfig
): Promise<AxiosResponse> {
  let finalConfig = { ...config };
  if (token) {
    finalConfig = {
      ...config,
      headers: {
        ...(config.headers || {}),

        Authorization: `Bearer ${token}`,
      },
    };
  }

  return api().request(finalConfig);
}
